(function () {
  const root = document.getElementById("citas-gate");
  if (!root) return;
  const d = root.dataset;

  const $ = (id) => document.getElementById(id);
  const esc = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const errorEl = $("citas-error");
  const step1 = $("citas-step-1"), step2 = $("citas-step-2"), step3 = $("citas-step-3");
  const calEl = $("citas-calendar"), timesEl = $("citas-times");
  const dynEl = $("citas-dynamic-fields");
  const nameEl = $("citas-name"), emailEl = $("citas-email");
  const consent = $("citas-consent"), submitBtn = $("citas-submit"), successEl = $("citas-success");
  const cardBlock = $("citas-card-block"), chargeLine = $("citas-success-charge"), step2Btn = $("citas-to-3");
  const originalBtnLabel = submitBtn.textContent.trim();

  const showError = (m) => { errorEl.textContent = m || ""; if (m) window.scrollTo({ top: 0, behavior: "smooth" }); };
  const post = async (url, body) => {
    const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body || {}) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok || data.error) throw new Error(data.error || "Error de red. Intenta de nuevo.");
    return data;
  };
  // Días con garantía = viernes(5), sábado(6) o domingo(0), según el día "YYYY-MM-DD" (ya en tz CDMX).
  const isWeekendDay = (dayKey) => {
    const dow = new Date(dayKey + "T00:00:00Z").getUTCDay();
    return dow === 0 || dow === 5 || dow === 6;
  };

  // Estado
  let meta = null;          // { eventTypeUri, questions, timezone }
  let availability = {};     // { "YYYY-MM-DD": [{time,startTime}] }
  let selected = null;       // { startTime, day, isWeekend }
  let currentDay = null;     // "YYYY-MM-DD" del día elegido en el calendario
  let viewYear, viewMonth;   // mes visible (0-index)

  if (typeof Stripe === "undefined") { showError("No se pudo cargar el módulo de pago. Recarga la página."); return; }
  const stripe = Stripe(d.stripePk);
  let card = null;
  let cardComplete = false;

  const monthBounds = (y, m) => {
    const start = new Date(Date.UTC(y, m, 1));
    const end = new Date(Date.UTC(y, m + 1, 1));
    return { start: start.toISOString(), end: end.toISOString() };
  };

  async function loadMonth(y, m) {
    calEl.innerHTML = "<p>Cargando disponibilidad…</p>";
    timesEl.innerHTML = "";
    const { start, end } = monthBounds(y, m);
    try {
      const res = await post(d.urlAvailability, { eventTypeUri: meta.eventTypeUri, start, end });
      availability = res.days || {};
    } catch (e) { showError(e.message); availability = {}; }
    renderCalendar(y, m);
  }

  function renderCalendar(y, m) {
    viewYear = y; viewMonth = m;
    const monthName = new Date(y, m, 1).toLocaleDateString("es-MX", { month: "long", year: "numeric" });
    const firstDow = new Date(y, m, 1).getDay();
    const daysInMonth = new Date(y, m + 1, 0).getDate();
    let html = '<div class="citas-cal__head">' +
      '<button type="button" class="citas-cal__nav" data-nav="-1">‹</button>' +
      '<strong>' + monthName + '</strong>' +
      '<button type="button" class="citas-cal__nav" data-nav="1">›</button></div>';
    ["D","L","M","M","J","V","S"].forEach((x) => html += '<div class="citas-cal__dow">' + x + '</div>');
    for (let i = 0; i < firstDow; i++) html += '<button class="citas-day citas-day--empty" disabled></button>';
    for (let day = 1; day <= daysInMonth; day++) {
      const key = y + "-" + String(m + 1).padStart(2, "0") + "-" + String(day).padStart(2, "0");
      const has = !!availability[key];
      html += '<button type="button" class="citas-day' + (has ? ' citas-day--has' : '') + '" data-day="' + key + '"' + (has ? '' : ' disabled') + '>' + day + '</button>';
    }
    calEl.innerHTML = html;
  }

  function renderTimes(key) {
    selected = null;
    const slots = availability[key] || [];
    timesEl.innerHTML = slots.map((s) =>
      '<button type="button" class="citas-time" data-start="' + s.startTime + '">' + s.time + '</button>').join("");
  }

  calEl.addEventListener("click", (e) => {
    const nav = e.target.closest("[data-nav]");
    if (nav) {
      let m = viewMonth + parseInt(nav.dataset.nav, 10), y = viewYear;
      if (m < 0) { m = 11; y--; } if (m > 11) { m = 0; y++; }
      const now = new Date();
      if (y < now.getFullYear() || (y === now.getFullYear() && m < now.getMonth())) return;
      loadMonth(y, m); return;
    }
    const day = e.target.closest("[data-day]");
    if (day && !day.disabled) {
      calEl.querySelectorAll(".citas-day--sel").forEach((n) => n.classList.remove("citas-day--sel"));
      day.classList.add("citas-day--sel");
      currentDay = day.dataset.day;
      renderTimes(day.dataset.day);
    }
  });

  timesEl.addEventListener("click", (e) => {
    const t = e.target.closest("[data-start]");
    if (!t) return;
    timesEl.querySelectorAll(".citas-time--sel").forEach((n) => n.classList.remove("citas-time--sel"));
    t.classList.add("citas-time--sel");
    selected = { startTime: t.dataset.start, day: currentDay, isWeekend: isWeekendDay(currentDay) };
    goStep(2);
  });

  function renderDynamicFields() {
    dynEl.innerHTML = (meta.questions || []).map((q) => {
      const id = "q_" + q.position;
      const qn = esc(q.name);
      if (q.type === "single_select" && q.options.length) {
        const opts = q.options.map((o) => '<option value="' + esc(o) + '">' + esc(o) + '</option>').join("");
        return '<label class="citas-gate__label">' + qn +
          '<select id="' + id + '" data-qname="' + qn + '"' + (q.required ? " required" : "") +
          '><option value="">Selecciona…</option>' + opts + '</select></label>';
      }
      if (q.type === "multi_select" && q.options.length) {
        const boxes = q.options.map((o) =>
          '<label class="citas-check"><input type="checkbox" value="' + esc(o) + '"> ' + esc(o) + '</label>').join("");
        return '<div class="citas-gate__label">' + qn +
          '<div class="citas-checks" data-qgroup="' + qn + '">' + boxes + '</div></div>';
      }
      const type = q.type === "phone_number" ? "tel" : "text";
      return '<label class="citas-gate__label">' + qn +
        '<input type="' + type + '" id="' + id + '" data-qname="' + qn + '"' + (q.required ? " required" : "") + '></label>';
    }).join("");
  }

  function collectAnswers() {
    const answers = {};
    dynEl.querySelectorAll("[data-qname]").forEach((el) => { answers[el.dataset.qname] = el.value.trim(); });
    dynEl.querySelectorAll("[data-qgroup]").forEach((group) => {
      const checked = Array.from(group.querySelectorAll("input[type=checkbox]:checked")).map((c) => c.value);
      answers[group.dataset.qgroup] = checked.join(", ");
    });
    return answers;
  }

  function goStep(n) {
    showError("");
    step1.hidden = n !== 1; step2.hidden = n !== 2; step3.hidden = n !== 3;
    if (n === 2) {
      const weekend = !!(selected && selected.isWeekend);
      cardBlock.hidden = !weekend;
      step2Btn.textContent = weekend ? "Continuar" : "Agendar";
      if (weekend && !card) {
        card = stripe.elements().create("card");
        card.mount("#citas-card-element");
        card.on("change", (e) => { cardComplete = e.complete; showError(e.error ? e.error.message : ""); });
      }
    }
  }

  $("citas-back-2").addEventListener("click", () => goStep(1));
  $("citas-back-3").addEventListener("click", () => goStep(2));

  step2Btn.addEventListener("click", () => {
    if (!nameEl.value.trim() || !emailEl.value.trim()) return showError("Completa tu nombre y correo.");
    for (const q of meta.questions || []) {
      if (!q.required) continue;
      if (q.type === "multi_select") {
        const group = dynEl.querySelector('[data-qgroup="' + CSS.escape(q.name) + '"]');
        if (group && !group.querySelector("input:checked")) return showError("Responde: " + q.name);
      } else {
        const el = dynEl.querySelector('[data-qname="' + CSS.escape(q.name) + '"]');
        if (el && !el.value.trim()) return showError("Responde: " + q.name);
      }
    }
    if (selected && selected.isWeekend) {
      if (!cardComplete) return showError("Completa los datos de la tarjeta.");
      goStep(3);
    } else {
      submitBooking();
    }
  });

  consent.addEventListener("change", () => { submitBtn.disabled = !consent.checked; });

  submitBtn.addEventListener("click", () => {
    if (!consent.checked || !selected) return;
    submitBooking();
  });

  async function submitBooking() {
    if (!selected) return;
    const weekend = !!selected.isWeekend;
    const activeBtn = weekend ? submitBtn : step2Btn;
    const restLabel = weekend ? originalBtnLabel : "Agendar";
    activeBtn.disabled = true; activeBtn.textContent = "Agendando…"; showError("");
    const name = nameEl.value.trim(), email = emailEl.value.trim();
    let eventUri = null;
    try {
      // 1) Reservar en Calendly
      let booking;
      try {
        booking = await post(d.urlBook, {
          eventTypeUri: meta.eventTypeUri, startTime: selected.startTime,
          name, email, phone: "",
          answers: collectAnswers(),
          questions: (meta.questions || []).map((q) => ({ name: q.name, position: q.position })),
        });
      } catch (e) {
        if (e.message === "calendly_error") throw new Error("No se pudo agendar ese horario (puede que ya no esté disponible). Intenta de nuevo o elige otro.");
        throw e;
      }
      eventUri = booking.eventUri;
      if (weekend) {
        // 2) Guardar tarjeta en Stripe
        const si = await post(d.urlSetupIntent, {
          name, email, phone: "",
          consentAccepted: true, consentText: consent.parentElement.textContent.trim(),
        });
        const result = await stripe.confirmCardSetup(si.client_secret, {
          payment_method: { card: card, billing_details: { name: name, email: email } },
        });
        if (result.error) throw new Error(result.error.message);
        // 3) Etiquetar
        await post(d.urlFinalize, { ok: true, eventUri, startTime: selected.startTime, email });
      }
      // Éxito
      if (!weekend) chargeLine.hidden = true;
      step2.hidden = true; step3.hidden = true; successEl.hidden = false;
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      // Rollback: solo en fin de semana (entre semana el único paso es `book`; si falla, no hay reserva que cancelar).
      if (weekend && eventUri) {
        try { await post(d.urlFinalize, { ok: false, eventUri, startTime: selected.startTime, email }); }
        catch (rbErr) { console.error("[citas] rollback de la reserva falló:", eventUri, rbErr); }
      }
      showError((err.message || "Ocurrió un error.") + " Intenta de nuevo.");
      activeBtn.disabled = false; activeBtn.textContent = restLabel;
    }
  }

  // Init
  (async function init() {
    try {
      meta = await post(d.urlMeta, {});
      renderDynamicFields();
      const now = new Date();
      await loadMonth(now.getFullYear(), now.getMonth());
    } catch (e) { showError("No se pudo cargar la disponibilidad. Recarga la página."); }
  })();
})();
